import VentilationCalculator from '../../Roofing/VentilationCalculator/Index';

const CMSVentilationCalculator = ({}) => {
  return (
    <VentilationCalculator />
  )
};

export default CMSVentilationCalculator;
